const connectionSelectors = {
	getConnectionStatus: state => state.connectionStatus || {},
};

export default connectionSelectors;
